// extracted by mini-css-extract-plugin
export default {"input":"PhoneInput_input__Gmptf","error":"PhoneInput_error__CQj-V","label--required":"PhoneInput_label--required__agYQn"};